const ThemeFunc = (function () {
  const windowUrl = location.href;

  // Returns the element specified by the target as a param.

  const getEl = (target, is_all = false, _parent) => {
    let parent = _parent || document;
    if (is_all) {
      return parent.querySelectorAll(target);
    }
    return parent.querySelector(target);
  };

  // Returns a boolean whether the current device is mobile or not.

  const isMobile = () => {
    if (
      window.matchMedia('(any-hover: none)').matches ||
      document.documentElement.clientWidth < 700
    ) {
      return true;
    }
    return false;
  };

  const initAccordionIndexLoad = () => {
    if (windowUrl.includes('?c=')) {
      // Detect FAQ category id from the url.
      const targetId = windowUrl.split('?c=')[1];

      let El = {
        faqCategoryItem: `#${targetId}`,
      };

      let El__faqCategoryItem = getEl(El.faqCategoryItem);

      if (El__faqCategoryItem) {
        El__faqCategoryItem.click();
      }
    }
  };

  const initFaqCategoryToggle = () => {
    if (!isMobile()) {
      return;
    }

    let El = {
      faqToggle: '.faq__toc-toggle',
      faqCategory: '.faq__toc',
    };

    let El__faqToggle = getEl(El.faqToggle);
    let El__faqCategory = getEl(El.faqCategory);
    let is_open = false;

    if (El__faqToggle) {
      let faqCategoryInnerHeight = El__faqCategory.scrollHeight;

      El__faqToggle.addEventListener('click', () => {
        El__faqToggle.classList.toggle('open');
        if (is_open) {
          is_open = false;
          El__faqCategory.style.height = '0px';
        } else {
          is_open = true;
          El__faqCategory.style.height = `${faqCategoryInnerHeight}px`;
        }
      });
    }
  };

  const initProductInfoTabs = () => {
    let El = {
      tabHeader: '.info-tab-header-item',
      activeTabHeader: '.info-tab-header-item.active',
      tabContent: '.info-tab-content-block',
      activeTabContent: '.info-tab-content-block.active',
    };
    getEl(El.tabHeader, true).forEach((tab) => {
      tab.addEventListener('click', () => {
        let link = tab.dataset.link;
        let target = document.querySelector(`${El.tabContent}[data-content="${link}"]`);

        getEl(El.activeTabHeader).classList.remove('active');
        getEl(El.activeTabContent).classList.remove('active');

        tab.classList.add('active');
        target.classList.add('active');
      });
    });
  };

  const initBackToTop = () => {
    let El = {
      backBtn: '.back-to-top',
    };
    let El__backBtn = getEl(El.backBtn);
    let timer = null;
    if (El__backBtn) {
      if (timer != null) {
        clearTimeout(timer);
      }
      timer = setTimeout(() => {
        let scrollTop = document.documentElement.scrollTop;
        if (scrollTop > 30) {
          El__backBtn.classList.add('visible');
        } else {
          El__backBtn.classList.remove('visible');
        }
      }, 300);

      El__backBtn.addEventListener('click', () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      });
    }
  };

  const isScrolledIntoView = () => {
    const el = document.querySelector('.announcement-bar');
    if (!el) {
      return false;
    }
    var rect = el.getBoundingClientRect();
    var elemBottom = rect.bottom;
    var isVisible = elemBottom > el.clientHeight;
    document.documentElement.style.setProperty('--announcement-bar-is-sticky', isVisible ? 1 : 0);
  };

  removeCharmsByUrl = (url) => {
    fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
    }).finally(() => {
      document.dispatchEvent(new CustomEvent('cart:refresh'));
    });
    return false;
  };

  const initGlobalRemoveCharms = () => {
    // observer to detect cart drawer and add click event to remove charms
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'childList') {
          if (mutation.addedNodes.length > 0) {
            const drawer = mutation.addedNodes[0];
            const charms = document
              .querySelector('#cart-drawer')
              .querySelectorAll('[data-remove-charms]');
            if (charms.length > 0) {
              charms.forEach((charm) => {
                if (charm.dataset.processed) {
                  return;
                }
                charm.dataset.processed = true;
                charm.addEventListener('click', (e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  const url = charm.dataset.removeCharms;
                  removeCharmsByUrl(url);
                  return false;
                });
              });
            }
          }
        }
      });
    });

    observer.observe(document.querySelector('#cart-drawer'), {
      childList: true,
      subtree: true,
    });
  };

  const contactBTN = () => {
    console.log('Loading Contact Btn');
    const contactEl = document.querySelectorAll('.contact-drawer__item');
    if (!contactEl) {
      return false;
    }
    contactEl.forEach((item) => {
      item.addEventListener('click', (e) => {
        if (e.target.closest('.contact-drawer__item').classList.contains('accordion')) {
          e.target.closest('.contact-drawer__item').classList.toggle('is-open');
          let content = e.target.closest('.contact-drawer__item').nextElementSibling;
          if (content.style.maxHeight) {
            content.style.maxHeight = null;
          } else {
            content.style.maxHeight = content.scrollHeight + 'px';
          }
        } else if (e.target.closest('.contact-drawer__item').classList.contains('email-us')) {
          const drawer = document.querySelector('#contact-drawer');
          drawer.hide();
          LiveChatWidget.init();
          LiveChatWidget.call('maximize');
        }
      });
    });
    const clientAdvisorEL = document.querySelector('.contact_client_advisor_btn button');
    if (!clientAdvisorEL) {
      return false;
    }
    clientAdvisorEL.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      if (typeof ga === 'function') {
        ga('send', 'event', 'Button', 'Click', 'Client Advisor PDP');
      }
      const drawer = document.querySelector(`[aria-controls="contact-drawer"]`);
      if (drawer.ariaExpanded !== 'true') {
        drawer.click();
      }
      return false;
    });
  };

  const sidebarSubnavLinkOpen = () => {
    const menuBtn = document.querySelector('button[aria-controls="sidebar-menu"]');
    console.log('Loading sidebar links');
    if (!menuBtn) {
      return false;
    }
    // menuBtn.addEventListener("click", () => {
    //   // Force open subnavs with 1 link
    //   var subnavs = document.querySelectorAll(".accordion-always-opened, .sidebar-group-collections");
    //   if (subnavs.length > 0) {
    //     subnavs.forEach(function(subnav) {
    //       subnav.ariaExpanded = true;
    //       subnav.open = true;
    //       subnav.querySelector(".header-sidebar__nested-linklist").style.opacity = 1;
    //       subnav.querySelector(".header-sidebar__nested-linklist").style.tranform = "translateY(0)";
    //     });
    //   }
    // });
  };

  const initWishlist = () => {
    if (!window.SwymCallbacks) {
      window.SwymCallbacks = [];
    }

    window.SwymCallbacks.push(checkWishlistItemCount);
    window.SwymCallbacks.push(checkWishlistAPI);
    checkWishlistAPI();

    function checkWishlistItemCount(swat) {
      swat.fetch(function (products) {
        if (products.length > 0) {
          document.querySelector('.header-nav--wishlist').classList.add('has-list');
        } else {
          document.querySelector('.header-nav--wishlist').classList.remove('has-list');
        }
        document.querySelectorAll('.wishlist-item-count').forEach((count) => {
          count.innerText = products.length;
          count.classList.remove('hidden');
        });
      });
    }

    function checkWishlistAPI() {
      const per_observer = new PerformanceObserver((list) => {
        for (const entry of list.getEntries()) {
          if (entry.initiatorType == 'xmlhttprequest') {
            if (
              entry.name.includes('/recordWishlistAction') ||
              entry.name.includes('/epiRecordWishlist')
            ) {
              window.SwymCallbacks.push(checkWishlistItemCount);
            }
          }
        }
      });
      per_observer.observe({ entryTypes: ['resource'] });
    }
  };

  const initAnchorScroll = () => {
    const hash = window.location.hash.replace('#', '');
    const anchorElems = document.querySelectorAll('[data-anchor-link]');
    if (anchorElems.length) {
      anchorElems.forEach((elem) => {
        let sectionId = elem.id.replace('section-', '');
        if (hash && hash === sectionId) {
          elem.scrollIntoView({ behavior: 'smooth' });
        }
      });
    }
  };

  return {
    isMobile: isMobile,
    getEl: getEl,
    initAccordionIndexLoad: initAccordionIndexLoad,
    initFaqCategoryToggle: initFaqCategoryToggle,
    initProductInfoTabs: initProductInfoTabs,
    initBackToTop: initBackToTop,
    initGlobalRemoveCharms: initGlobalRemoveCharms,
    isScrolledIntoView: isScrolledIntoView,
    initWishlist: initWishlist,
    contactBTN: contactBTN,
    sidebarSubnavLinkOpen: sidebarSubnavLinkOpen,
    initAnchorScroll: initAnchorScroll,
  };
})();

document.addEventListener('DOMContentLoaded', (event) => {
  ThemeFunc.initAccordionIndexLoad();
  ThemeFunc.initFaqCategoryToggle();
  // ThemeFunc.initProductInfoTabs();
  ThemeFunc.initGlobalRemoveCharms();
  ThemeFunc.isScrolledIntoView();
  ThemeFunc.initWishlist();
  ThemeFunc.contactBTN();
  ThemeFunc.sidebarSubnavLinkOpen();

  // Move properties[Donation] input to main product form
  const donationInput = document.querySelector('input[name="properties[Donation]"]');
  if (donationInput) {
    const productForm = document.querySelector(
      ".product-info [data-block-type='buy-buttons'] form"
    );
    if (productForm) {
      productForm.appendChild(donationInput);
    }
  }

  console.log('Loading this');
});

window.addEventListener('load', () => {
  ThemeFunc.initProductInfoTabs();
  ThemeFunc.initAnchorScroll();
});

document.addEventListener('scroll', () => {
  ThemeFunc.initBackToTop();
  ThemeFunc.isScrolledIntoView();
});

document.addEventListener('gwp:added', () => {
  // Reload if on cart page
  if (window.location.pathname === '/cart') {
    window.location.reload();
    return;
  }
  // Open cart drawer
  document.dispatchEvent(new CustomEvent('cart:refresh'));
  const cartBtn = document.querySelector('[aria-controls="cart-drawer"]');
  if (cartBtn && cartBtn?.ariaExpanded !== 'true') {
    cartBtn.click();
  }
});

// Track Showroom Appointment form submission (Klaviyo form ID: ViKJwX)
// Fires a Meta Pixel custom conversion event when the form is submitted.
window.addEventListener('klaviyoForms', function (e) {
  if (e.detail.type === 'submit' && e.detail.formId === 'ViKJwX') {
    if (typeof fbq === 'function') {
      fbq('trackCustom', 'AppointmentRequest');
    }
    if (typeof gtag === 'function') {
      gtag('event', 'AppointmentRequest', {
        event_category: 'Klaviyo Form',
        event_label: 'ViKJwX',
      });
    }
  }
});
